import CustomModal from "./CustomModal";
import { useWolfTracsState } from "../../hooks/redux/useWolfTracsState";
import { useDispatch } from "react-redux";
import { closeTermsAndConditionsModal } from "../../actions/ModalActions";

export const TermsAndConditionsModal = () => {

    const { isOpen, content, modalTitle } = useWolfTracsState(s => s.modals.termsAndConditionsModal);
    const dispatch = useDispatch();

    return (
        <CustomModal
            isModalOpen={isOpen}
            includeCloseIcon
            modalTitle={modalTitle ?? undefined}
            __onCleanup={() => dispatch(closeTermsAndConditionsModal())}
        >
            { content && <div dangerouslySetInnerHTML={{ __html: content }} /> }
        </CustomModal>
    );
};